import axios from '@/core/axios'

import { ListOrdersDto, ListOrdersRes } from '../dtos/list-orders'

export default class OrderRepository {
    /**
     * This will list all the orders for the logged in customer
     */
    async listOrdersForCustomer({
        page,
        perPage,
    }: ListOrdersDto): Promise<ListOrdersRes> {
        const { data } = await axios.get<ListOrdersRes>(
            '/customers/me/orders',
            {
                params: {
                    limit: perPage,
                    offset: (page - 1) * perPage,
                },
            },
        )
        return data
    }
}
